export default __webpack_public_path__ + "static/topic12-d2a8f588e088be98cc180fe1fde81c1a.png";